/* eslint-disable no-unused-vars */
import React, { useMemo } from 'react';
import { arrayOf, string } from 'prop-types';
import { useIntl } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useConfiguration } from '../../../context/configurationContext';
import { parse } from '../../../util/urlHelpers';
import DropdownFilterEnum from '../DropdownFilterEnum/DropdownFilterEnum';
import { createResourceLocatorString } from '../../../util/routes';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';

import css from './SearchPageStyles.module.css';

export const SEARCH_PARAM_NAME_CATEGORY = 'category';
export const SEARCH_PARAM_NAME_TYPE = 'type';

const restCategories = ['trailers', 'boatEngines', 'other'];

const priority = [
  'Motorboten',

  'Sloepen',
  'Zeilboten',
  "RIB's",
  'Sportboot',
  'Jetski',

  'Boottrailers',
  'Bootmotoren',
  'Overig',
];

export const configsByKey = listingFieldsConfig =>
  listingFieldsConfig?.reduce((configs, conf) => ({ ...configs, [conf.key]: conf }), {});

export const getDropdownOptions = (config, items, intl) => {
  return config?.enumOptions
    ?.filter(option => {
      if (option.option === 'mooring') return false;

      if (config.key === 'category' || config.key === 'type') {
        return items.includes(option.option);
      }
      return false;
    })
    ?.map(option => ({
      ...option,
      value: option.category
        ? `${option.category.replace(/-/g, '/')}/${option.option}`
        : option.option,
      searchString: intl.formatMessage({ id: option.label }),
      label: intl.formatMessage({ id: option.label }),
      group: restCategories.some(cat => cat === option.option) ? 'rest' : 'main',
    }))
    ?.sort((a, b) => {
      const aIndex = priority.indexOf(a.label);
      const bIndex = priority.indexOf(b.label);
      return (aIndex === -1 ? Infinity : aIndex) - (bIndex === -1 ? Infinity : bIndex);
    });
};

/**
 * Build sport boat option object (non-mutating).
 * You can swap label/searchString to use intl.formatMessage if you have a translation id.
 */
const makeSportBoatOption = intl => ({
  option: 'sport',
  label: intl.formatMessage({ id: 'General.listing.type.powerBoats.sport' }),
  value: 'sport',
  searchString: intl.formatMessage({ id: 'General.listing.type.powerBoats.sport' }),
  searchParamName: 'pub_type',
});

const CategoryFilter = props => {
  const { categoryOptions, ...rest } = props;

  const routeConfiguration = useRouteConfiguration();
  const config = useConfiguration();
  const intl = useIntl();
  const location = useLocation();
  const history = useHistory();
  const { search, pathname, state } = location;

  const listingFields = config?.listing?.listingFields;
  const fieldConfigs = configsByKey(listingFields);

  const categoryDropdownOptions = useMemo(
    () => getDropdownOptions(fieldConfigs?.category, categoryOptions, intl) || [],
    [fieldConfigs?.category, categoryOptions, intl]
  );

  const handleCategoryReset = () => {
    const searchString = createResourceLocatorString(
      'SearchPage',
      routeConfiguration,
      {},
      {
        ...parse(search),
        category: [],
        type: [],
      }
    );
    history.replace(searchString, state);
  };

  return (
    <>
      <DropdownFilterEnum
        options={categoryDropdownOptions}
        searchParamName={SEARCH_PARAM_NAME_CATEGORY}
        placeholder={intl.formatMessage({ id: 'Global.category' })}
        dropdownInputClassName={css.dropdownLabel}
        onValueReset={handleCategoryReset}
        disableInternalSort
        {...rest}
      />
    </>
  );
};

CategoryFilter.propTypes = {
  categoryOptions: arrayOf(string).isRequired,
};

export default CategoryFilter;
